export default {"src":"/_next/static/media/mortar-icon.27cac5a9.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};